module.exports = __webpack_public_path__ + "img/comment-black-oval-bubble-shape.ab454932.png";